import React from "react";

const SvgcheckLine = (props) => (
  <svg
    width="20"
    height="18"
    viewBox="0 0 7 18"
    fill={props.fill}
    stroke="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g transform="translate(0.000000,16.000000) scale(0.100000,-0.100000)">
      <path
        d="M97 93 c-35 -36 -37 -36 -57 -18 -11 10 -20 14 -20 8 0 -5 9 -18 20
 -28 20 -19 22 -18 62 23 23 23 40 44 37 46 -3 3 -21 -11 -42 -31z"
      />
    </g>
  </svg>
);

export default SvgcheckLine;
